import React from 'react'

const LoadingGif = () => <div style={{margin:'auto'}}>Loading...</div>

export default LoadingGif



// WEBPACK FOOTER //
// ./src/components/Loading-gif.js